// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type CampaignBannerHomepageQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type CampaignBannerHomepageQuery = (
  { __typename?: 'Query' }
  & { organisation: (
    { __typename?: 'OrganisationModelGQLBase' }
    & Pick<PrivateSchemaTypes.OrganisationModelGqlBase, 'id' | 'color'>
  ), me: (
    { __typename?: 'UserModelSelf' }
    & Pick<PrivateSchemaTypes.UserModelSelf, 'id' | 'first_name' | 'display_name'>
    & { activeBanners: Array<(
      { __typename?: 'CampaignBannerModel' }
      & Pick<PrivateSchemaTypes.CampaignBannerModel, 'id' | 'text' | 'header' | 'button_caption' | 'button_link'>
      & { image?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'DocumentModel' }
        & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
        & { imageVariants: Array<(
          { __typename?: 'ImageVariantModel' }
          & Pick<PrivateSchemaTypes.ImageVariantModel, 'size_key' | 'cdnUrl'>
        )> }
      )> }
    )> }
  ) }
);

export type CaptureBannerAnalyticEventMutationVariables = PrivateSchemaTypes.Exact<{
  bannerId: PrivateSchemaTypes.Scalars['PositiveInt'];
  eventType: PrivateSchemaTypes.CampaignAnalyticEventTypeEnum;
  timestamp: PrivateSchemaTypes.Scalars['DateTime'];
}>;


export type CaptureBannerAnalyticEventMutation = (
  { __typename?: 'Mutation' }
  & { banner?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'CampaignBannerModel' }
    & Pick<PrivateSchemaTypes.CampaignBannerModel, 'id'>
    & { captureAnalyticEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignAnalyticEventModel' }
      & Pick<PrivateSchemaTypes.CampaignAnalyticEventModel, 'timestamp'>
    )> }
  )> }
);


export const CampaignBannerHomepageDocument = gql`
    query CampaignBannerHomepage {
  organisation {
    id
    color
  }
  me {
    id
    first_name
    display_name
    activeBanners {
      id
      text
      header
      button_caption
      button_link
      image {
        id
        cdnUrl
        imageVariants {
          size_key
          cdnUrl
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignBannerHomepageQuery__
 *
 * To run a query within a React component, call `useCampaignBannerHomepageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignBannerHomepageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignBannerHomepageQuery({
 *   variables: {
 *   },
 * });
 */
export function useCampaignBannerHomepageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CampaignBannerHomepageQuery, CampaignBannerHomepageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignBannerHomepageQuery, CampaignBannerHomepageQueryVariables>(CampaignBannerHomepageDocument, options);
      }
export function useCampaignBannerHomepageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignBannerHomepageQuery, CampaignBannerHomepageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignBannerHomepageQuery, CampaignBannerHomepageQueryVariables>(CampaignBannerHomepageDocument, options);
        }
export type CampaignBannerHomepageQueryHookResult = ReturnType<typeof useCampaignBannerHomepageQuery>;
export type CampaignBannerHomepageLazyQueryHookResult = ReturnType<typeof useCampaignBannerHomepageLazyQuery>;
export type CampaignBannerHomepageQueryResult = Apollo.QueryResult<CampaignBannerHomepageQuery, CampaignBannerHomepageQueryVariables>;
export const CaptureBannerAnalyticEventDocument = gql`
    mutation captureBannerAnalyticEvent($bannerId: PositiveInt!, $eventType: CampaignAnalyticEventTypeEnum!, $timestamp: DateTime!) {
  banner(id: $bannerId) {
    id
    captureAnalyticEvent(eventType: $eventType, timestamp: $timestamp) {
      timestamp
    }
  }
}
    `;
export type CaptureBannerAnalyticEventMutationFn = Apollo.MutationFunction<CaptureBannerAnalyticEventMutation, CaptureBannerAnalyticEventMutationVariables>;

/**
 * __useCaptureBannerAnalyticEventMutation__
 *
 * To run a mutation, you first call `useCaptureBannerAnalyticEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaptureBannerAnalyticEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [captureBannerAnalyticEventMutation, { data, loading, error }] = useCaptureBannerAnalyticEventMutation({
 *   variables: {
 *      bannerId: // value for 'bannerId'
 *      eventType: // value for 'eventType'
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useCaptureBannerAnalyticEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CaptureBannerAnalyticEventMutation, CaptureBannerAnalyticEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CaptureBannerAnalyticEventMutation, CaptureBannerAnalyticEventMutationVariables>(CaptureBannerAnalyticEventDocument, options);
      }
export type CaptureBannerAnalyticEventMutationHookResult = ReturnType<typeof useCaptureBannerAnalyticEventMutation>;
export type CaptureBannerAnalyticEventMutationResult = Apollo.MutationResult<CaptureBannerAnalyticEventMutation>;
export type CaptureBannerAnalyticEventMutationOptions = Apollo.BaseMutationOptions<CaptureBannerAnalyticEventMutation, CaptureBannerAnalyticEventMutationVariables>;